import { ShortcutKey } from '~/constants';
import { KeyboardShortcut } from '~/utils/keyboard-shortcut';

interface AnyClass {
	constructor: {
		name: string;
	};
}

interface TableShortcuts {
	selectPreviousRecord(): void;
	selectNextRecord(): void;
	selectPreviousPage(): void;
	selectNextPage(): void;
	selectFirstPage(): void;
	selectLastPage?: () => void;
	canUseSelectRecordOrPage(): boolean;
}

/**
 * bindAcurityTableShortcuts binds keyboard shortcuts related to acurity-table.
 *
 * We currently cannot make be handled by the <acurity-table> component because we need to be able
 * to retrieve the selected record and store it at the <classic-form> component level.
 *
 * Ideally in the future, we would pass a callback into the <acurity-table> component and allow it
 * to handle this logic.
 */
export function bindAcurityTableShortcuts(
	instance: AnyClass,
	functions: TableShortcuts,
) {
	KeyboardShortcut.subscribe(
		instance,
		ShortcutKey.PrevRecord,
		functions.selectPreviousRecord,
		functions.canUseSelectRecordOrPage,
	);
	KeyboardShortcut.subscribe(
		instance,
		ShortcutKey.NextRecord,
		functions.selectNextRecord,
		functions.canUseSelectRecordOrPage,
	);
	KeyboardShortcut.subscribe(
		instance,
		ShortcutKey.PrevPage,
		functions.selectPreviousPage,
		functions.canUseSelectRecordOrPage,
	);
	KeyboardShortcut.subscribe(
		instance,
		ShortcutKey.NextPage,
		functions.selectNextPage,
		functions.canUseSelectRecordOrPage,
	);
	KeyboardShortcut.subscribe(
		instance,
		ShortcutKey.PrevPageAlt,
		functions.selectPreviousPage,
		functions.canUseSelectRecordOrPage,
	); // WEBUI-2246
	KeyboardShortcut.subscribe(
		instance,
		ShortcutKey.NextPageAlt,
		functions.selectNextPage,
		functions.canUseSelectRecordOrPage,
	); // WEBUI-2246
	KeyboardShortcut.subscribe(
		instance,
		ShortcutKey.FirstPage,
		functions.selectFirstPage,
		functions.canUseSelectRecordOrPage,
	);
	KeyboardShortcut.subscribe(
		instance,
		ShortcutKey.FirstPageAlt,
		functions.selectFirstPage,
		functions.canUseSelectRecordOrPage,
	); // WEBUI-2246

	const supportsSelectLastPage: boolean =
		functions.selectLastPage !== undefined;
	if (supportsSelectLastPage) {
		KeyboardShortcut.subscribe(
			instance,
			ShortcutKey.LastPage,
			functions.selectLastPage,
			functions.canUseSelectRecordOrPage,
		);
		KeyboardShortcut.subscribe(
			instance,
			ShortcutKey.LastPageAlt,
			functions.selectLastPage,
			functions.canUseSelectRecordOrPage,
		); // WEBUI-2246
	}
}
